// The phone: the caster the player reads, or null. A touch has no tooltip, so
// a tap on a caster opens its pane under the board, in the seat of the log.
// Added 2026-10-13, from a design pass. Garrett: "do it all". Until then a
// phone player had no way to read a spell in a match: the tooltip is for a
// mouse, and a tap on a vessel casts. The log and the pane share one seat, so
// one closes the other.

import type { CasterId } from '../content/casters';
import { createStore } from '../lib/store';
import { logOpenStore } from './logOpen';

export const casterReadStore = createStore<CasterId | null>(null);

/** Opens the pane of a caster. A second tap on the same caster closes it. */
export const readCaster = (id: CasterId): void => {
  logOpenStore.set(false);
  casterReadStore.set((current) => (current === id ? null : id));
};

export const closeCasterRead = (): void => casterReadStore.set(null);

logOpenStore.subscribe((open) => {
  if (open) closeCasterRead();
});
